import * as z from "zod";

const ServiceLevelKeySchema = z.object({
  carrier: z.string(),
  service: z.string(),
});

export const ShippingCarriersFlatTeamSettingsSchema = z.object({
  "outboundLabels/disabledRedoServiceLevels": z
    .array(ServiceLevelKeySchema)
    .nullish(),
  "outboundLabels/carrierAccountDisabledServiceLevels": z
    .array(
      z.object({
        carrierAccountId: z.string(),
        disabledServiceLevels: z.array(ServiceLevelKeySchema).nullish(),
      }),
    )
    .nullish(),
  "outboundLabels/labelPrebuyCarrierAccountIds": z.array(z.string()).nullish(),
  "returns/merchantCarrierReturnLabels/carrierAccountDisabledServiceLevels": z
    .array(
      z.object({
        carrierAccountId: z.string(),
        disabledServiceLevels: z.array(ServiceLevelKeySchema).nullish(),
      }),
    )
    .nullish(),
});
